import React from "react";
import imageUrl from "utils/imageUrl";
import { Link } from "react-router-dom";
function HomeBox() {
  return (
    <div className="box">
      <div className="heading">
        <h2>Wallet Setup</h2>
      </div>
      <div className="para">import an existing wallet or create a new</div>
      <div className="chain-info">
        <img
          src={imageUrl("digital_wallet.jpg")}
          alt="chain-img"
          className="chain-img"
        />
      </div>
      <div class="send-btn mt-5">
        <Link to="/enter-recovery-phase">
          <button type="button" class="btn w-100">
            <span>import using private Key</span>
          </button>
        </Link>
      </div>

      <div class="send-btn mt-5">
        <Link to="/create-password">
          <button type="button" class="btn w-100">
            <span> Create New Wallet </span>
          </button>
        </Link>
      </div>
    </div>
  );
}

export default HomeBox;
